export const ONETRUST_GROUPS = {
	STRICT: 'C0001',
	PERFORMANCE: 'C0002',
	FUNCTIONAL: 'C0003',
	TARGETING: 'C0004',
}

const CONSENT_UPDATED_EVENT = 'delight:consent-updated'

export function getActiveOneTrustGroups() {
	if (typeof window === 'undefined') return ''
	return (
		(typeof window.OnetrustActiveGroups === 'string' && window.OnetrustActiveGroups) ||
		(typeof window.OptanonActiveGroups === 'string' && window.OptanonActiveGroups) ||
		''
	)
}

export function hasOneTrustGroup(groupId) {
	const groups = getActiveOneTrustGroups()
	if (!groups || !groupId) return false
	return groups.indexOf(',' + groupId + ',') !== -1
}

export function isOneTrustReady() {
	return getActiveOneTrustGroups().length > 0
}

/**
 * Run callback once OneTrust has reported groups (Accept, Reject, or saved prefs),
 * or after timeout if the CMP never loads. Returns an unsubscribe function.
 */
export function whenOneTrustReady(callback, timeoutMs = 8000) {
	if (typeof window === 'undefined') return () => {}

	let called = false
	let timer = null

	const run = () => {
		if (called) return
		called = true
		if (timer) window.clearTimeout(timer)
		window.removeEventListener(CONSENT_UPDATED_EVENT, run)
		callback()
	}

	if (isOneTrustReady()) {
		run()
		return () => {}
	}

	window.addEventListener(CONSENT_UPDATED_EVENT, run)
	timer = window.setTimeout(run, timeoutMs)

	return () => {
		if (timer) window.clearTimeout(timer)
		window.removeEventListener(CONSENT_UPDATED_EVENT, run)
	}
}

/**
 * Run callback once the OneTrust group is active.
 * Returns an unsubscribe function.
 */
export function whenOneTrustGroup(groupId, callback) {
	if (typeof window === 'undefined') return () => {}

	let called = false
	const run = () => {
		if (called || !hasOneTrustGroup(groupId)) return
		called = true
		window.removeEventListener(CONSENT_UPDATED_EVENT, run)
		callback()
	}

	run()
	if (!called) {
		window.addEventListener(CONSENT_UPDATED_EVENT, run)
	}

	return () => window.removeEventListener(CONSENT_UPDATED_EVENT, run)
}
